// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editableLabel_W4GRQ {
    position: relative;
    display: inline-block;
}

.labelContainer_r9j3Z {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0.75rem;
    border-radius: 0.375rem;
    cursor: pointer;
    transition: all 0.2s ease;
}

.labelContainerHover_jBSej {
    background-color: var(--f9fafb-background);
}

.labelText_tWM91 {
    -webkit-user-select: none;
            user-select: none;
}

.pencilIcon_gAAZJ {
    transition: all 0.2s ease;
    color: var(--9ca3af-color);
    width: 16px;
    height: 16px;
}

.pencilIconHover_EMJoF {
    color: var(--6b7280-color);
}

.pencilIconHidden_cXaA_ {
    opacity: 0;
    transform: translateX(-0.5rem);
}

.pencilIconVisible_SJ1p4 {
    opacity: 1;
    transform: translateX(0);
}

.comboboxContainer_RxsxM {
    position: relative;
    min-width: 12rem;
}

.comboboxButton_rsUVh {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0.75rem;
    text-align: left;
    background-color: var(--white-background);
    border: 1px solid var(--dddddd-border);
    border-radius: 0.375rem;
    box-shadow: 0 1px 2px 0 var(--black-005-shadow);
    outline: none;
    cursor: pointer;
    transition: all 0.15s ease;
}


.buttonText_sFq_W {
    color: var(--888-contacts-color);
}

.buttonTextPlaceholder_aqBx4 {
    color: var(--9ca3af-color);
}

.chevronIcon_g0ZGQ {
    width: 16px;
    height: 16px;
    transition: transform 0.2s ease;
}

.chevronIconRotated_O4kx5 {
    transform: rotate(180deg);
}

.optionsList_QERrZ {
    position: absolute;
    z-index: 10;
    width: 100%;
    margin-top: 0.25rem;
    background-color: var(--white-background);
    border: 1px solid var(--dddddd-border);
    border-radius: 0.375rem;
    box-shadow: 0 10px 15px -3px var(--_0000001a-shadow),
    0 4px 6px -2px var(--black-005-shadow);
    max-height: 15rem;
    overflow-y: auto;
}

.emptyOption_cjLTM {
    padding: 0.5rem 0.75rem;
    color: var(--6b7280-color);
    font-size: 0.875rem;
}

.optionButton_Kuz39 {
    width: 100%;
    padding: 0.5rem 0.75rem;
    text-align: left;
    background: none;
    border: none;
    cursor: pointer;
    transition: background-color 0.15s ease;
}

.optionButtonHover_Ykez8 {
    background-color: var(--f9fafb-background);
}

.optionText_WqZha {
    color: var(--black-color);
}

.optionTextSelected_NsH_B {
    font-weight: 500;
    color: var(--888-contacts-color);
}

.actionButtons_N4EqA {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 0.5rem;
}

.actionButton_xccMD {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    border: none;
    border-radius: 0.25rem;
    cursor: pointer;
    transition: all 0.15s ease;
    background: none;
}

.confirmButton_TuXOu {
    color: var(--059669-color);
}

.confirmButtonHover_L4Sz6 {
    color: var(--_0c8e6d-background);
    background-color: var(--dcfce7-background);
}

.cancelButton_bDwBv {
    color: var(--6b7280-color);
}

.cancelButtonHover_aqvTL {
    color: var(--_5a5a67-background);
    background-color: var(--f9fafb-background);
}

.customLabel_Hm_hT {
    background-color: var(--e0f2fe-background);
    border: 1px solid var(--cbd5e1-border);
    color: var(--1d4ed8-background);
}

`, "",{"version":3,"sources":["webpack://./src/components/contacts/EditableLabel.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,gBAAgB;IAChB,yCAAyC;IACzC,sCAAsC;IACtC,uBAAuB;IACvB,+CAA+C;IAC/C,aAAa;IACb,eAAe;IACf,0BAA0B;AAC9B;;;AAGA;IACI,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,yCAAyC;IACzC,sCAAsC;IACtC,uBAAuB;IACvB;0CACsC;IACtC,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;IAChC,0CAA0C;AAC9C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;IAChC,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;IAC1C,sCAAsC;IACtC,+BAA+B;AACnC","sourcesContent":[".editableLabel {\n    position: relative;\n    display: inline-block;\n}\n\n.labelContainer {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.5rem 0.75rem;\n    border-radius: 0.375rem;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.labelContainerHover {\n    background-color: var(--f9fafb-background);\n}\n\n.labelText {\n    user-select: none;\n}\n\n.pencilIcon {\n    transition: all 0.2s ease;\n    color: var(--9ca3af-color);\n    width: 16px;\n    height: 16px;\n}\n\n.pencilIconHover {\n    color: var(--6b7280-color);\n}\n\n.pencilIconHidden {\n    opacity: 0;\n    transform: translateX(-0.5rem);\n}\n\n.pencilIconVisible {\n    opacity: 1;\n    transform: translateX(0);\n}\n\n.comboboxContainer {\n    position: relative;\n    min-width: 12rem;\n}\n\n.comboboxButton {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0.5rem 0.75rem;\n    text-align: left;\n    background-color: var(--white-background);\n    border: 1px solid var(--dddddd-border);\n    border-radius: 0.375rem;\n    box-shadow: 0 1px 2px 0 var(--black-005-shadow);\n    outline: none;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n\n.buttonText {\n    color: var(--888-contacts-color);\n}\n\n.buttonTextPlaceholder {\n    color: var(--9ca3af-color);\n}\n\n.chevronIcon {\n    width: 16px;\n    height: 16px;\n    transition: transform 0.2s ease;\n}\n\n.chevronIconRotated {\n    transform: rotate(180deg);\n}\n\n.optionsList {\n    position: absolute;\n    z-index: 10;\n    width: 100%;\n    margin-top: 0.25rem;\n    background-color: var(--white-background);\n    border: 1px solid var(--dddddd-border);\n    border-radius: 0.375rem;\n    box-shadow: 0 10px 15px -3px var(--_0000001a-shadow),\n    0 4px 6px -2px var(--black-005-shadow);\n    max-height: 15rem;\n    overflow-y: auto;\n}\n\n.emptyOption {\n    padding: 0.5rem 0.75rem;\n    color: var(--6b7280-color);\n    font-size: 0.875rem;\n}\n\n.optionButton {\n    width: 100%;\n    padding: 0.5rem 0.75rem;\n    text-align: left;\n    background: none;\n    border: none;\n    cursor: pointer;\n    transition: background-color 0.15s ease;\n}\n\n.optionButtonHover {\n    background-color: var(--f9fafb-background);\n}\n\n.optionText {\n    color: var(--black-color);\n}\n\n.optionTextSelected {\n    font-weight: 500;\n    color: var(--888-contacts-color);\n}\n\n.actionButtons {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-top: 0.5rem;\n}\n\n.actionButton {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n    padding: 0.25rem 0.5rem;\n    font-size: 0.875rem;\n    border: none;\n    border-radius: 0.25rem;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    background: none;\n}\n\n.confirmButton {\n    color: var(--059669-color);\n}\n\n.confirmButtonHover {\n    color: var(--_0c8e6d-background);\n    background-color: var(--dcfce7-background);\n}\n\n.cancelButton {\n    color: var(--6b7280-color);\n}\n\n.cancelButtonHover {\n    color: var(--_5a5a67-background);\n    background-color: var(--f9fafb-background);\n}\n\n.customLabel {\n    background-color: var(--e0f2fe-background);\n    border: 1px solid var(--cbd5e1-border);\n    color: var(--1d4ed8-background);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editableLabel": `editableLabel_W4GRQ`,
	"labelContainer": `labelContainer_r9j3Z`,
	"labelContainerHover": `labelContainerHover_jBSej`,
	"labelText": `labelText_tWM91`,
	"pencilIcon": `pencilIcon_gAAZJ`,
	"pencilIconHover": `pencilIconHover_EMJoF`,
	"pencilIconHidden": `pencilIconHidden_cXaA_`,
	"pencilIconVisible": `pencilIconVisible_SJ1p4`,
	"comboboxContainer": `comboboxContainer_RxsxM`,
	"comboboxButton": `comboboxButton_rsUVh`,
	"buttonText": `buttonText_sFq_W`,
	"buttonTextPlaceholder": `buttonTextPlaceholder_aqBx4`,
	"chevronIcon": `chevronIcon_g0ZGQ`,
	"chevronIconRotated": `chevronIconRotated_O4kx5`,
	"optionsList": `optionsList_QERrZ`,
	"emptyOption": `emptyOption_cjLTM`,
	"optionButton": `optionButton_Kuz39`,
	"optionButtonHover": `optionButtonHover_Ykez8`,
	"optionText": `optionText_WqZha`,
	"optionTextSelected": `optionTextSelected_NsH_B`,
	"actionButtons": `actionButtons_N4EqA`,
	"actionButton": `actionButton_xccMD`,
	"confirmButton": `confirmButton_TuXOu`,
	"confirmButtonHover": `confirmButtonHover_L4Sz6`,
	"cancelButton": `cancelButton_bDwBv`,
	"cancelButtonHover": `cancelButtonHover_aqvTL`,
	"customLabel": `customLabel_Hm_hT`
};
export default ___CSS_LOADER_EXPORT___;
